<div class="iss-side-nav-menu-item">
  <div class="icon">
    <iss-icon [name]="iconName"></iss-icon>
  </div>
  <div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
    {{ title }}
  </div>
</div>
